var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id !== "" ? _vm.$t("modify") : _vm.$t("add"),
            visible: _vm.dialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "old_acc_id", label: _vm.$t("oldRoleId") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputRoleId") },
                    model: {
                      value: _vm.paramsData.old_acc_id,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "old_acc_id", $$v)
                      },
                      expression: "paramsData.old_acc_id"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "lr", staticStyle: { opacity: "0" } },
                    [_vm._v(_vm._s(_vm.$t("needBindThirdPartyAccount")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "new_acc_id", label: _vm.$t("newRoleId") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: { placeholder: _vm.$t("pleaseInputRoleId") },
                    model: {
                      value: _vm.paramsData.new_acc_id,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "new_acc_id", $$v)
                      },
                      expression: "paramsData.new_acc_id"
                    }
                  }),
                  _c("div", { staticClass: "lr" }, [
                    _vm._v(_vm._s(_vm.$t("needBindThirdPartyAccount")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "x-c" }, [
            _vm._v(_vm._s(_vm.$t("rebindNotice")))
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.dataFormSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }